import { render } from "./StaticPages.vue?vue&type=template&id=c5c5db16"
import script from "./StaticPages.vue?vue&type=script&lang=js"
export * from "./StaticPages.vue?vue&type=script&lang=js"

import "./StaticPages.vue?vue&type=style&index=0&id=c5c5db16&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__